import { Button, Divider, Flex, Modal } from "antd";

interface IDocstoreSectionDeleteModal {
  isModalOpen: boolean;
  handleOk: () => void;
  handleCancel: () => void;
}

export function DocstoreSectionDeleteModal({
  isModalOpen,
  handleOk,
  handleCancel,
}: IDocstoreSectionDeleteModal) {
  return (
    <Modal
      title="Удалить?"
      onCancel={handleCancel}
      centered
      open={isModalOpen}
      footer={
        <Flex gap="small" justify="start">
          <Button onClick={handleOk} type="primary">
            Да
          </Button>
          <Button onClick={handleCancel}>Нет</Button>
        </Flex>
      }
    >
      Вы действительно хотите удалить?
      <Divider />
    </Modal>
  );
}
